import React from "react";

export enum ITableRowTestValue {
    PASSED = "passed",
    FAILED = "failed",
}

export const TableRowTestContext = React.createContext<ITableRowTestValue | undefined>(undefined);
